import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "./App.css";
import "./styles/AppCommonStyling.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Custom
import NewStudentForm from "./pages/New Student Process/NewStudentForm";
import ManagerAuthScreen from "./pages/Manager Auth Components/ManagerAuthScreen";
import ManagerDashboard from "./pages/Manager Dashboard Components/ManagerDashboard";
import { ThemeProvider } from "./context/ThemeContext";
import { AuthProvider } from "./context/AuthContext";
import { RemoteConfigProvider } from "./context/RemoteConfigContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AuthTest from "./components/AuthTest";
import SuperControlDashboard from "./pages/SuperControlDashboard/SuperControlDashboard";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <RemoteConfigProvider>
          <Router
            future={{
              v7_startTransition: true,
              v7_relativeSplatPath: true,
            }}
          >
            <ToastContainer
              position="bottom-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              rtl
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
            <Routes>
              <Route path="/" element={<Navigate to="/manager/auth" />} />
              <Route
                path="/newstudent/:userField/:ID/:groupID"
                element={<NewStudentForm />}
              />
              <Route path="/manager/auth" element={<ManagerAuthScreen />} />
              <Route
                path="/manager/auth/register"
                element={
                  <Navigate
                    to="/manager/auth"
                    state={{ showSignUp: true }}
                    replace
                  />
                }
              />
              <Route
                path="/super_dashboard"
                element={<SuperControlDashboard />}
              />
              <Route
                path="/manager/auth/dashboard/:userID"
                element={
                  <ProtectedRoute>
                    <ManagerDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/usagepolicy"
                element={
                  <div className="pdf-container">
                    <iframe
                      src="https://docs.google.com/gview?url=https://drive.google.com/uc?id=1UasHp-oJvFryaDV4UpsKkkSLIYe-5J4-&embedded=true"
                      title="Usage Policy"
                      className="pdf-iframe"
                    />
                  </div>
                }
              />
            </Routes>
          </Router>
        </RemoteConfigProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
